import React from "react";
import { Query } from "react-apollo";
import { Link } from "react-router-dom";
import { Row, Col, Tag, Card, Spin } from "antd";
// import numeral from "numeral";
import moment from "moment";
import Barcode from "react-barcode";

import GetLastOrder from "../GraphQL/Query/GetLastOrder";
import UserContext from "../Contexts/UserContext";
import { parseStatus } from "../Utils/catalogues";

import Image from "../Components/Image/Image";

const LastOrder = () => {
  return (
    <UserContext.Consumer>
      {({ profile }) => (
        <Query
          query={GetLastOrder}
          variables={{ userId: profile.username }}
          fetchPolicy="cache-and-network"
        >
          {({ loading, error, data }) => {
            if (loading && !data.getLastOrder) return <Spin />;
            if (error) return <p>Error :(</p>;
            const { getLastOrder = {} } = data;
            const {
              id,
              serviceTitle,
              service,
              status,
              createdAt
            } = getLastOrder;
            const {
              tags,
              description,
              deliveryHours,
              category,
              specs
            } = service;
            return (
              <Row>
                <Col span={24}>
                  <div className="detail-image">
                    <Image
                      className="img__service-detail"
                      picture={category.picture}
                    />
                  </div>
                  <div
                    style={{ position: "absolute", top: 5, padding: "2rem" }}
                  >
                    <div style={{ color: "white", fontSize: "3.5rem" }}>
                      {serviceTitle}
                    </div>
                    <span style={{ color: "white" }}>{`(${
                      category.title
                    })`}</span>
                    <div>{tags.map(tag => <Tag key={tag}>{tag}</Tag>)}</div>
                  </div>
                  <Col span={24}>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 16 }}
                      lg={{ span: 16 }}
                      xl={{ span: 16 }}
                      style={{
                        padding: 32,
                        fontFamily: "Montserrat",
                        fontWeight: 400,
                        fontSize: "1.5rem"
                      }}
                    >
                      <p
                        style={{
                          lineHeight: 2,
                          textAlign: "justify"
                        }}
                      >
                        {description}
                      </p>
                      <h3
                        className="subtitle"
                        style={{ paddingLeft: "1.5rem" }}
                      >
                        Especificaciones
                      </h3>
                      <ul className="list">
                        {specs ? (
                          specs.map(spec => (
                            <li key={spec} className="list__item">
                              {spec}
                            </li>
                          ))
                        ) : (
                          <span>
                            Por el momento no hay ninguna especificación.
                          </span>
                        )}
                      </ul>
                    </Col>
                    <Col
                      xs={{ span: 20, offset: 2 }}
                      sm={{ span: 20, offset: 2 }}
                      md={{ span: 8, offset: 0 }}
                      lg={{ span: 8, offset: 0 }}
                      xl={{ span: 8, offset: 0 }}
                    >
                      <Col
                        xs={{ span: 24, offset: 0 }}
                        sm={{ span: 22, offset: 1 }}
                        md={{ span: 22, offset: 1 }}
                        lg={{ span: 20, offset: 2 }}
                        xl={{ span: 20, offset: 2 }}
                      >
                        <Card
                          style={{
                            boxShadow: "var(--shadow-super-light)",
                            fontSize: "1.5rem"
                          }}
                        >
                          <h3>Ticket</h3>
                          <div className="description-item">
                            <label>Fecha de entrega</label>
                            <span>
                              {moment(createdAt)
                                .add(deliveryHours || 72, "hours")
                                .format("dddd, D MMMM")}
                            </span>
                          </div>
                          <div className="description-item">
                            <label>Estatus</label>
                            <span>{parseStatus[status].title}</span>
                          </div>
                          <div className="description-item__line" />
                          <Col>
                            <div className="description-item__image">
                              <Barcode
                                value={id}
                                width={0.6}
                                height={70}
                                fontSize={10}
                              />
                            </div>
                          </Col>
                        </Card>
                      </Col>
                    </Col>
                  </Col>
                </Col>
                <Col
                  span={24}
                  style={{
                    flex: 1,
                    padding: "3rem",
                    display: "flex",
                    justifyContent: "center"
                  }}
                >
                  <Link
                    to={`orders/${id}`}
                    className="btn-index btn-white btn-animated"
                  >
                    Ir a detalle de la orden
                  </Link>
                </Col>
              </Row>
            );
          }}
        </Query>
      )}
    </UserContext.Consumer>
  );
};

export default LastOrder;



// WEBPACK FOOTER //
// ./src/Pages/LastOrder.js